// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5'
import 'babel-polyfill'

Vue.use(ElementUI)
Vue.prototype.$axios = 'axios'
Vue.prototype.$md5 = md5
Vue.config.productionTip = false
/* eslint-disable no-new */
window.Global = {
  // imgUrl: 'http://47.98.169.218:8083',
  imgUrl: "http://sign.xn--fjq0sg8h2zkivvwsonptcv2b.com",
   //'http://dev.qiahaochaoshi.com', //测试环境
  // 生产环境
  // domain: 'http://47.98.169.218:8083',
  // domain: 'http://dev.qiahaochaoshi.com', 
  domain: "http://sign.xn--fjq0sg8h2zkivvwsonptcv2b.com/api",
  get: function (url, params, callback) {
    var me = this
    url = me.domain + url
    axios({
      url: url,
      method: 'get',
      params: params
    }).then(function (response) {
      if (response.status === 401 || response.status === 403) {  
        window.Global.removeLocalStorage('token')
        window.Global.removeLocalStorage('username')
        window.Global.removeLocalStorage('password')
        router.push({name:"indexLogin"})
        } else{
          if (typeof (callback) === 'function') {
            callback(response)
          }
        }
    }).catch(function (error) {
      // var rs = error.response.data
      // me.removeLocalStorage('token')
      // me.removeLocalStorage('username')
      // me.removeLocalStorage('password')
      // me.removeLocalStorage('roleid')
      // window.location.reload()
    })
  },
  post: function (url, params, callback) {
    var me = this
    url = me.domain + url
    axios({
      url: url,
      method: 'post',
      data: params,
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }]
    }).then(function (response) {
      if (response.status == 401 || response.status == 403) {  
        console.log(12345678765432123456789876543)
        window.Global.removeLocalStorage('token')
        window.Global.removeLocalStorage('username')
        window.Global.removeLocalStorage('password')
        router.push({name:"indexLogin"})
        alert(response.data.message)
        } else{
          if (typeof (callback) === 'function') {
            callback(response)
          }
        }
    }).catch(function (error) {
      // alert("账号密码不正确")
      // var rs = error.response.data
      //  if (rs.status === false) {
      //    me.removeLocalStorage('token')
      //    me.removeLocalStorage('username')
      //    me.removeLocalStorage('password')
      //    window.location.reload()
      // }
    })
  },
  upload: function (url, params, callback) {
    console.log('上传');
    var me = this
    url = me.domain + url
    axios({
      url: url,
      method: 'post',
      data: params,
      'Content-Type': 'multipart/form-data'
    }).then(function (response) {
      if (typeof (callback) === 'function') {
        callback(response)
      }
    }).catch(function (error) {
      var rs = error.response.data
      if (rs.status === false) {
        window.Global.removeLocalStorage('token')
        window.Global.removeLocalStorage('username')
        window.Global.removeLocalStorage('password')
        // window.location.reload()
      }
    })
  },
  checkToken(){
    if(window.Global.getLocalStorage('token')){
      let tokend = window.Global.getLocalStorage('token')
      window.Global.post("/user/checkToken",{
      token: tokend
    }, rs=> {
      console.log("checkToken",tokend,rs)
      // 测试判断
      if (rs.success === false) {
        window.Global.removeLocalStorage('token')
        window.Global.removeLocalStorage('username')
        window.Global.removeLocalStorage('password')
        router.push({name:"indexLogin"})
      }
    })
    }else{
      window.Global.removeLocalStorage('token')
      window.Global.removeLocalStorage('username')
      window.Global.removeLocalStorage('password')
      router.push({name:"indexLogin"})
    }
  },
  setLocalStorage: function (name, token) {
    window.localStorage.setItem(name, token)
  },
  getLocalStorage: function (name) {
    return window.localStorage.getItem(name)
  },
  removeLocalStorage: function (name) {
    window.localStorage.removeItem(name)
  }
}
axios.interceptors.request.use(config => { // 这里的config包含每次请求的内容
  console.log(config)
  // 判断localStorage中是否存在api_token
  if (window.Global.getLocalStorage('token')) {
  // 存在将token写入 request header
    config.headers['Access-Token'] = `${window.Global.getLocalStorage('token')}`
  }
  return config
}, err => {
  return Promise.reject(err)
})
axios.interceptors.response.use(response => {
  return response
}, error => {
  return Promise.resolve(error.response)
})
function checkStatus (response) {
  // 如果http状态码正常，则直接返回数据
  if (response && (response.status === 200 || response.status === 304 ||
      response.status === 400)) {
    return response
  }
  // 异常状态下，把错误信息返回去
  return {
    status: -404,
    msg: '网络异常'
  }
}
function checkCode (res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.status === -404) {
    alert(res.data.msg)
  }
  if (res.data && (!res.status)) {
    // alert(res.data.error_msg)
  }
  return res
}
// 请求方式的配置
export default {
  post (url, data) { // post
    return axios({
      method: 'post',
      baseURL: '/backapis',
      url,
      data: qs.stringify(data),
      timeout: 5000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }).then(
      (res) => {
        return checkStatus(res)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  },
  get (url, params) { // get
    return axios({
      method: 'get',
      baseURL: '/backapis',
      url,
      params, // get 请求时带的参数
      timeout: 5000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  },
  upload (url, data) { //
    return axios({
      method: 'get',
      baseURL: '/backapis',
      url,
      data, // get 请求时带的参数
      timeout: 50000,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  }
}
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js